import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { API_ENDTPOINTS } from '@models/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class DonationService {
  private document = inject(DOCUMENT);


  donateNow(inputs) {
    const form = this.document.createElement('form');
    form.setAttribute('medthod', 'post');
    form.setAttribute('action', API_ENDTPOINTS.CONTRIBUTE_NOW);
    for (const input of inputs) {
      const i = this.document.createElement('input');
      i.setAttribute('type', 'hidden');
      i.setAttribute('name', input.name);
      i.setAttribute('value', input.value);
      form.appendChild(i);
    }
    this.document.body.appendChild(form).submit();
  }
}
